import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import './styles/index.css';
import { logCrash } from './shell/crashLog';
import { installStandaloneHeight } from './shell/standaloneHeight';
import { routes } from './shell/routes';
import { UpdateGate } from './shell/UpdateGate';
import { AudioGate } from './shell/AudioGate';
import { initApp } from './state/actions';
import { installHealthReporting } from './health/report';
import { measureOnPlay, startRenderQueue } from './recordings/edits';
import { installPlaybackVolume } from './recordings/volume';
import { armWarmup } from './shell/warmup/start';
import { armTours } from './shell/tour/signals';

// Phone health (2026-10-09): uncaught errors and rejections into the device's error log, first of all.
installHealthReporting();
// The loading screen's warm-up (shell/warmup/) waits for the data and is up from the first frame.
armWarmup(initApp());
// "Mitä uutta" and the other tours shown once per person (shell/tour/): only in the real page, never in unit tests.
armTours();
// Own recordings (2026-10-06): the device volume and levelling on every player; trims waiting to upload.
installPlaybackVolume(measureOnPlay);
startRenderQueue();

const router = createBrowserRouter(routes);

installStandaloneHeight();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* onError: every crash an error screen catches is logged with its component stack. */}
    <RouterProvider router={router} onError={logCrash} />
    {/* The loading screen that installs a new version on open / return (shell/UpdateGate.tsx), and on
        a cold start then prepares the dictionary, the show lines and every section (shell/warmup/). */}
    <UpdateGate />
    {/* Then every recording onto the device before the app opens (shell/AudioGate.tsx). */}
    <AudioGate />
  </StrictMode>,
);
